import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import type { ResumeData } from '../lib/types';
import SubHeader from '../components/SubHeader';
import Summary from '../components/resume/Summary';
import TechnicalSkills from '../components/resume/TechnicalSkills';
import Employment from '../components/resume/Employment';
import Education from '../components/resume/Education';
import ProfessionalMemberships from '../components/resume/ProfessionalMemberships';
import Icon from '../components/Icon';

export default function ResumePage() {
  // ?for=software loads `resume_data_software.json` server-side; the access token
  // in the URL (legacy `/resume/:access` route) gets forwarded into the api layer
  // via the cookie that AccessRedirect set.
  const { access } = useParams<{ access?: string }>();
  const [searchParams] = useSearchParams();
  const resumeFor = searchParams.get('for') ?? undefined;

  const [data, setData] = useState<ResumeData | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.getResume({ for: resumeFor }).then((d) => {
      if (!cancelled) setData(d);
    });
    return () => {
      cancelled = true;
    };
  }, [resumeFor, access]);

  function print() {
    // Server-rendered PDF download (replaces old PhantomJS pipeline).
    window.location.href = api.getPrintUrl();
  }

  if (!data) return null;

  return (
    <>
      <SubHeader
        title="RESUME"
        right={
          <a href="#" onClick={(e) => { e.preventDefault(); print(); }}>
            <Icon name="print" /> <span className="hidden-xs">PRINT</span>
          </a>
        }
      />

      <div className="site-page with-subheader">
        <div className="resume-doc">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <h2 className="my-name">Chris Boustead</h2>
                <div className="email">
                  <a href="mailto:cbous1@gmail.com">cbous1@gmail.com</a>
                </div>
                <div className="website">
                  <a href="http://chrisboustead.com">chrisboustead.com</a>
                </div>
              </div>
              <div className="col-sm-6 text-right">
                <div className="address">
                  642 W Hazel St.<br />Orlando, FL 32804
                </div>
                <div className="phone">
                  <a href="tel:2035061223">(203) 506-1223</a>
                </div>
              </div>
            </div>
          </div>

          <div>
            <Summary data={data} />
            <TechnicalSkills data={data} />
            <Employment data={data} />
            <Education data={data} />
            <ProfessionalMemberships data={data} />
          </div>
        </div>
      </div>
    </>
  );
}
